import { Component, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AppService } from '@services/app.service';
import { Subject, takeUntil } from 'rxjs';
import { countryOptions } from '@/modals/CountryCode';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { LoginResponse } from "@/modals/loginDetails";
import { ErrorResponse } from "@/modals/errorResponse";
import { Title } from "@angular/platform-browser";


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  openOTPModal = false;
  buttonShow = true;
  firstValue: string = '';
  secondValue: string = '';
  thirdValue: string = '';
  fourthValue: string = '';
  email: string;
  loginDetails: LoginResponse | undefined;
  options = countryOptions;
  buttonClicked = false;
  isLocalhost = window.location.hostname === 'localhost';
  showPassword: boolean = false;

  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private titleService: Title,
  ) {
   
  }

  ngOnInit() {
    const token = localStorage.getItem('authToken');
    const type = localStorage.getItem('userType');
  }

  // Login Form Group
  loginForm = new UntypedFormGroup({
    username: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator]),
    password: new UntypedFormControl("", [
      Validators.required,
      Validators.nullValidator]),
  });

  public loginErrors = {
    username: '',
    password: '',
  }

  onSubmit(){
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    this.login()
  }

  get f() {
    return this.loginForm.controls;
  }

  login(){
this.appService.adminLogin(this.loginForm.value)
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          this.loginDetails = data;
          console.log("getDetails",this.loginDetails)
          localStorage.setItem('authToken', this.loginDetails.token);
          localStorage.setItem('userType', this.loginDetails.loginDetails.userType);
          localStorage.setItem('userId', String(this.loginDetails.loginDetails.melatturRegId));
          const loginTime = new Date().getTime(); // Current time in milliseconds
          localStorage.setItem('loginTime', loginTime.toString());
          this.spinner.hide();
          this.openOTPModal = false;
          if (this.loginDetails.loginDetails.userType == 'User') {
            this.toastr.success('OTP Verified, Login successfully');
            this.router.navigate(['/upcoming-event']);
          } else if (this.loginDetails.loginDetails.userType == 'ADMIN') {
            this.toastr.success('OTP Verified, Login successfully');
            this.router.navigate(['/main/booking-details']);
          } else {
            this.toastr.error('Access Denied');
          }
        }, (error: any) => {
          console.error("Error:", error);
          this.spinner.hide();

          const errorMessage = error?.error?.message || "Something went wrong, please try again";
          this.toastr.error(errorMessage);
        });
    }

    togglePassword() {
    this.showPassword = !this.showPassword;
  }
  }
  
